import { useMutation } from "@tanstack/react-query";

import UserService from "../../../service/UserService";

const updateBlogSetup = async ({ userId, setupRequest }) => {
  const response = await UserService.updateBlogSetupRequest({ userId, blogSetup: setupRequest });
  return response;
};

export default function useSubmitSetupRequest() {
  const mutation = useMutation({ mutationFn: updateBlogSetup });

  const run = async ({ userId, setupRequest }, options) => {
    try {
      await mutation.mutateAsync({ userId, setupRequest }, options);
    } catch (e) {
      console.log(e);
    }
  };

  const { isPending, isError, error } = mutation;
  return [run, { isPending, isError, error }];
}
